// @ts-nocheck
import { useState, useRef, useCallback } from 'react';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import { useSelector } from 'react-redux';
// Update the import path to the correct relative location
import moment from 'moment';
import { forEach, isObject } from 'lodash';
import { mapDetailsToScreeningEntities } from '../components/ReferralIsOm/entityUtils';
import { CoreUtils } from '../utils/Utils';
import { postBulkVerdict } from '../utils/BulkVerdict';
import { API_ENDPOINTS } from '../const/ApiEndpoints';
import { selectAuth } from '../state/slices/appSlice';
import useInitiate from './useInitiate';
import useRiskRating from './useRiskRating';
import useCommonReducer from './useCommonReducer';
import useTransactionScreening from './useTransactionScreening';
import consts, {
  Dummy_PEP_DATA,
  Dummy_SANCTION_DATA,
  Dummy_AMS_DATA,
  DEFAULT_COMMENT,
} from '../const/Const';

/**
 * @function useInitialScreening
 * @description a custom hook which handles APIs related to Initial screening screen
 * @returns {object} object
 */

export default function useInitialScreening() {
  const { enqueueSnackbar } = useSnackbar();
  const {
    getRiskParameters,
    riskParameters,
    industry,
    product,
    occupation,
    crrMandatoryParameterList,
  } = useInitiate();
  const { getTransactionParameters, channel, productType, transactionType } =
    useTransactionScreening();
  const {
    fetchRiskList,
    resetRiskData,
    calculateRiskRating,
    riskList,
    riskValue,
    riskResult,
    setRiskList,
    setRiskValue,
    systemRisk,
    setSystemRisk,
    riskResponse,
  } = useRiskRating();
  const {
    dispatch,
    setInitialPageIndexInitialScreening,
    setInitialPageSizeInitialScreening,
  } = useCommonReducer();
  const { mergeResults, mergeAllDetails, sortByParty } = CoreUtils;
  const [userList, setUserList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [sanctionsList, setSanctionsList] = useState([]);
  const [pepList, setPepList] = useState([]);
  const [amsList, setAmsList] = useState([]);
  const [legalList, setLegalList] = useState([]);
  const [corporateList, setCorporateList] = useState([]);
  const [legalDocument, setLegalDocument] = useState([]);
  const [fetchUsersPageCount, setFetchUsersPageCount] = useState(0);
  const [hasData, setHasData] = useState(true);
  const [totalUsers, setTotalUsers] = useState(0);
  const [initialScreeningTotalCount, setInitialScreeningTotalCount] =
    useState(0);
  const [disabled, setdisabled] = useState(true);
  const [cardDetails, setCardDetails] = useState({});
  const [analystsList, setAnalystsList] = useState([]);
  const [referralList, setReferralList] = useState([]);
  const [dedupeInformation, setDedupeInformation] = useState([]);
  const [recipientDedupeInformation, setRecipientDedupeInformation] = useState(
    []
  );
  const [dedupeParameter, setDedupeParameter] = useState([]);
  const [templateList, setTemplateList] = useState([]);
  const [template, setTemplate] = useState([]);
  const [transferList, setTransferList] = useState([]);
  const fetchIdRef = useRef(0);
  const { user } = useSelector(selectAuth);

  // Demo Changes
  const [goodsList, setGoodsList] = useState([]);
  const [goodsListValue, setGoodsListValue] = useState([]);

  /**
   * @function resetAllList
   * @description A function to reset all lists
   * @returns {undefined}
   * @example resetAllList()
   */
  const resetAllList = () => {
    setSanctionsList([]);
    setPepList([]);
    setAmsList([]);
    setLegalList([]);
    setCorporateList([]);
  };
  /**
   * @function fetchUserList
   * @description A function to fetch User List
   * @returns {Promise} returns an axios promise
   */
  const fetchUserList = () => {
    setIsLoading(true);
    axios
      .get(API_ENDPOINTS.INITIAL_SCREENING_ALL_ANALYST)
      .then((response) => {
        setAnalystsList(response.data);
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  };
  /**
   * @function fetchReferralsList
   * @description A function to fetch Referrals List
   * @returns {Promise} returns an axios promise
   */
  const fetchReferralsList = () => {
    setIsLoading(true);
    axios
      .get(API_ENDPOINTS.INITIAL_SCREENING_REFERRALS)
      .then((response) => {
        setReferralList(response.data);
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  /**
   * @function fetchUsers
   * @description A function to implement pagination
   * @returns {Promise} returns an axios promise
   */
  const fetchUsers = useCallback(
    async ({
      pageSize,
      pageIndex,
      query,
      orderBy,
      status,
      days,
      checkerLevel,
      formData,
      alertList,
      alert,
      bookmark,
      team_type,
      channel,
      product,
      transaction_type,
      bookmarked,
      assignedStatus,
    }) => {
      // Give this fetch an ID
      fetchIdRef.current += 1;
      const fetchId = fetchIdRef.current;

      // Your server could send back total page count.
      setIsLoading(true);

      try {
        const response = await axios.get(
          API_ENDPOINTS.INITIAL_SCREENING_ALERT_LIST,
          {
            params: {
              page: pageIndex + 1,
              screen: 'initial',
              ...(pageSize ? { pagesize: pageSize } : {}),
              query: query?.trim(),
              orderBy,
              checkerLevel,
              status,
              days,
              ...formData,
              alert: alert ?? '',
              alert_list: alertList ? alertList.join().toLowerCase() : '',
              ...(!bookmarked && {
                bookmark: bookmark !== '' ? bookmark : false,
              }),
              team_type,
              channel,
              product,
              transaction_type,
              is_assigned: assignedStatus,
            },
            loader: !query?.length,
          }
        );

        setIsLoading(false);

        if (fetchId === fetchIdRef.current) {
          setUserList(response.data);
          setTotalUsers(response.headers['x-total-count']);
          setFetchUsersPageCount(
            Math.ceil(response.headers['x-total-count'] / pageSize)
          );

          // Check if the last page is empty, and move to the previous page if needed
          if (response?.data?.length === 0 && pageIndex > 0) {
            const newPageIndex = Math.max(pageIndex - 1, 0);
            dispatch(setInitialPageSizeInitialScreening(pageSize));
            dispatch(setInitialPageIndexInitialScreening(newPageIndex));
            return fetchUsers({
              pageSize,
              pageIndex: newPageIndex,
              query,
              orderBy,
              status,
              days,
              checkerLevel,
              formData,
              alertList,
              alert,
              team_type,
            });
          }

          if (!Number(response.headers['x-total-count'])) {
            setHasData(false);
          }
        }

        return response;
      } catch (error) {
        setIsLoading(false);
        throw error;
      }
    },
    []
  );
  function buildModifiedFilters(filters) {
    const result = {};
    if (!isObject(filters)) return result;
    forEach(filters, (value, key) => {
      if (key === 'targetDateRange' && isObject(value)) {
        if (value?.start)
          result.targetStartDate = moment(value.start).format(
            consts.GLOBAL_DATE_FORMAT
          );
        if (value?.end)
          result.targetEndDate = moment(value.end).format(
            consts.GLOBAL_DATE_FORMAT
          );
        return;
      }
      if (key === 'initiatedDateRange' && isObject(value)) {
        if (value?.start)
          result.initiatedStartDate = moment(value.start).format(
            consts.GLOBAL_DATE_FORMAT
          );
        if (value?.end)
          result.initiatedEndDate = moment(value.end).format(
            consts.GLOBAL_DATE_FORMAT
          );
        return;
      }
      if (key === 'alerted') {
        result[key] =
          Array.isArray(value) && value.length === 1
            ? value.join(',')
            : Array.isArray(value)
            ? ''
            : value;
      } else {
        result[key] = Array.isArray(value) ? value.join(',') : value;
      }
    });
    return result;
  }
  const getInitialScreeningData = ({ page = 0, pageSize = 5, filters }) => {
    const modifiedFilters = buildModifiedFilters(filters);
    const params = {
      page: page + 1 || '',
      pagesize: pageSize || '',
      screen: 'initial',
      alert: modifiedFilters.alerted || '',
      search_type: modifiedFilters.searchType || '',
      initiate_start_date: modifiedFilters.initiatedStartDate || '',
      initiate_end_date: modifiedFilters.initiatedEndDate || '',
      risk_rating: modifiedFilters.riskType || '',
      target_start_date: modifiedFilters.targetStartDate || '',
      target_end_date: modifiedFilters.targetEndDate || '',
      team_id: modifiedFilters.team || '',
      query: modifiedFilters.search || '',
      selectedUsers: modifiedFilters.analyst || '',
      alert_list: (modifiedFilters.alertListType || '').toLowerCase(),
      onboarding_type: modifiedFilters.onboarding_type || '',
      party: modifiedFilters.party || '',
      transaction_product_type: modifiedFilters.transaction_product_type || '',
      channel: modifiedFilters.channel || '',
      bookmark: modifiedFilters.bookmark || '',
      industry: modifiedFilters.industry || '',
      transaction_type: modifiedFilters.transaction_type || '',
      occupation: modifiedFilters.occupation || '',
      product: modifiedFilters.product || '',
      country: modifiedFilters.country || '',
      field1: modifiedFilters.field1 || '',
      ...(modifiedFilters.team_type
        ? { team_type: modifiedFilters.team_type }
        : {}),
      is_assigned: modifiedFilters?.assignedStatus || '',
      team: modifiedFilters?.horizontalTeam || '',
      search_source: modifiedFilters?.search_source || '',
      manager_id: modifiedFilters.manager || '',
      search_format: modifiedFilters?.search_format || '',
      match_filter: modifiedFilters?.match_filter || '',
    };
    return axios
      .get(API_ENDPOINTS.INITIAL_SCREENING_ALERT_LIST, {
        params,
        loader: false,
      })
      .then((res) => {
        setInitialScreeningTotalCount(res.headers?.['x-total-count']);
        return {
          data: res.data,
          totalRowCount: res.headers?.['x-total-count'],
        };
      });
  };
  const getInitialTransactionUsers = ({ page = 0, pageSize = 5, filters }) => {
    const modifiedFilters = buildModifiedFilters(filters);

    const params = {
      page: page + 1 || '',
      pagesize: pageSize || '',
      screen: 'initial',
      alert: modifiedFilters.alerted || '',
      search_type: modifiedFilters.searchType || '',
      initiate_start_date: modifiedFilters.initiatedStartDate || '',
      initiate_end_date: modifiedFilters.initiatedEndDate || '',
      risk_rating: modifiedFilters.riskType || '',
      target_start_date: modifiedFilters.targetStartDate || '',
      target_end_date: modifiedFilters.targetEndDate || '',
      team_id: modifiedFilters.team || '',
      query: modifiedFilters.search || '',
      selectedUsers: modifiedFilters.analyst || '',
      alert_list: (modifiedFilters.alertListType || '').toLowerCase(),
      onboarding_type: modifiedFilters.onboarding_type || '',
      party: modifiedFilters.party || '',
      transaction_product_type: modifiedFilters.transaction_product_type || '',
      channel: modifiedFilters.channel || '',
      bookmark: modifiedFilters.bookmark || '',
      industry: modifiedFilters.industry || '',
      transaction_type: modifiedFilters.transaction_type || '',
      occupation: modifiedFilters.occupation || '',
      product: modifiedFilters.product || '',
      country: modifiedFilters.country || '',
      field1: modifiedFilters.field1 || '',
      ...(modifiedFilters.team_type
        ? { team_type: modifiedFilters.team_type }
        : {}),
      is_assigned: modifiedFilters?.assignedStatus || '',
      team: modifiedFilters?.horizontalTeam || '',
      search_source: modifiedFilters?.search_source || '',
      manager_id: modifiedFilters.manager || '',
      search_format: modifiedFilters?.search_format || '',
      match_filter: modifiedFilters?.match_filter || '',
    };
    return axios
      .get(API_ENDPOINTS.INITIAL_SCREENING_TRANSACTION_ALERT_LIST, {
        params,
        loader: false,
      })
      .then((res) => {
        setInitialScreeningTotalCount(res.headers?.['x-total-count']);
        return {
          data: res.data,
          totalRowCount: res.headers?.['x-total-count'],
        };
      });
  };

  /**
   * @function fetchTransactionUsers
   * @description A function to implement pagination
   * @returns {Promise} returns an axios promise
   */
  const fetchTransactionUsers = useCallback(
    async ({
      pageSize,
      pageIndex,
      query,
      orderBy,
      status,
      days,
      checkerLevel,
      formData,
      alertList,
      alert,
      bookmark,
      team_type,
      channel,
      product,
      transaction_type,
      bookmarked,
      common_queue,
    }) => {
      // Give this fetch an ID
      fetchIdRef.current += 1;
      const fetchId = fetchIdRef.current;

      // Your server could send back total page count.
      setIsLoading(true);

      try {
        const response = await axios.get(
          API_ENDPOINTS.INITIAL_SCREENING_TRANSACTION_ALERT_LIST,
          {
            params: {
              page: pageIndex + 1,
              screen: 'initial',
              ...(pageSize ? { pagesize: pageSize } : {}),
              query: query?.trim(),
              orderBy,
              checkerLevel,
              status,
              days,
              ...formData,
              alert: alert ?? '',
              alert_list: alertList ? alertList.join().toLowerCase() : '',
              ...(!bookmarked && {
                bookmark: bookmark !== '' ? bookmark : false,
              }),
              team_type,
              channel,
              product,
              transaction_type,
              common_queue,
            },
            loader: !query?.length,
          }
        );

        setIsLoading(false);

        if (fetchId === fetchIdRef.current) {
          setUserList(response.data);
          setTotalUsers(response.headers['x-total-count']);
          setFetchUsersPageCount(
            Math.ceil(response.headers['x-total-count'] / pageSize)
          );

          // Check if the last page is empty, and move to the previous page if needed
          if (response?.data?.length === 0 && pageIndex > 0) {
            const newPageIndex = Math.max(pageIndex - 1, 0);
            dispatch(setInitialPageSizeInitialScreening(pageSize));
            dispatch(setInitialPageIndexInitialScreening(newPageIndex));
            return fetchTransactionUsers({
              pageSize,
              pageIndex: newPageIndex,
              query,
              orderBy,
              status,
              days,
              checkerLevel,
              formData,
              alertList,
              alert,
              team_type,
            });
          }

          if (!Number(response.headers['x-total-count'])) {
            setHasData(false);
          }
        }

        return response;
      } catch (error) {
        setIsLoading(false);
        throw error;
      }
    },
    []
  );

  /**
   * @function fetchCardData
   * @description A function to fetch Card Data
   * @returns {Promise} returns an axios promise
   */
  const fetchCardData = (queryParams) => {
    setIsLoading(true);
    resetAllList();
    resetRiskData();
    return axios
      .get(
        `${API_ENDPOINTS.INITIAL_SCREENING_CARD_DETAILS}${queryParams.search_id}/`
      )
      .then(
        (response) => {
          setIsLoading(false);
          if (response?.data) {
            setCardDetails(response?.data);
            if (response.data?.failed_type) {
              const message = CoreUtils.getFailedTypeMessage(
                response.data.failed_type
              );
              if (message) {
                enqueueSnackbar(message, {
                  variant: 'warning',
                });
              }
            }
          }
        },
        () => {
          setIsLoading(false);
        }
      );
  };

  /**
   * @function fetchTransactionCardData
   * @description A function to fetch Card Data
   * @returns {Promise} returns an axios promise
   */
  const fetchTransactionCardData = (queryParams) => {
    setIsLoading(true);
    resetAllList();
    resetRiskData();
    return axios
      .get(
        `${API_ENDPOINTS.INITIAL_SCREENING_TRANSACTION_ALERT_LIST}${queryParams.transaction_id}/`
      )
      .then(
        (response) => {
          setIsLoading(false);
          if (response?.data) {
            const screeningEntities = mapDetailsToScreeningEntities(
              response.data
            );

            setCardDetails({
              ...response.data,
              screening_entities: screeningEntities,
            });

            if (response.data?.failed_type) {
              const message = CoreUtils.getFailedTypeMessage(
                response.data.failed_type
              );
              if (message) {
                enqueueSnackbar(message, {
                  variant: 'warning',
                });
              }
            }
          }
        },
        () => {
          setIsLoading(false);
        }
      );
  };
  /**
   * @function handleReview
   * @description A function to fetch review details
   * @returns {Promise} returns an axios promise
   */
  const handleReview = (queryParams) => {
    setIsLoading(true);
    const payload = {
      comment: queryParams?.comment,
      attachment: queryParams?.file?.name,
      results: queryParams?.results,
    };

    return axios
      .post(
        `${API_ENDPOINTS.REVIEW_DETAILS}${queryParams?.data?.search_id}/`,
        payload
      )
      .then(
        (response) => {
          setIsLoading(false);
          if (response?.data) {
            enqueueSnackbar(response?.data?.message, {
              variant: 'success',
            });
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        },
        (response) => {
          setIsLoading(false);
          enqueueSnackbar(response?.response?.data?.message, {
            variant: 'error',
          });
        }
      );
  };

  /**
   * @function moveIsToOm
   * @description A function to move data from initial screening to ongoing monitoring
   * @returns {Promise} returns an axios promise
   */
  const moveIsToOm = (data) => {
    return axios.post(API_ENDPOINTS.MOVE_IS_TO_OM, data).then(
      () => {
        setIsLoading(false);
        enqueueSnackbar('Moved Successfully.', {
          variant: 'success',
        });
      },
      () => {
        setIsLoading(false);
      }
    );
  };
  /**
   * @function updateUser
   * @description A function to update User details
   * @returns {Promise} returns an axios promise
   */
  const updateUser = (data) => {
    setIsLoading(true);
    axios
      .patch(`${API_ENDPOINTS.INITIAL_SCREENING_CARD_DETAILS}${data.id}/`, data)
      .then(
        (response) => {
          setIsLoading(false);
          if (response.status === 200) {
            setdisabled(!disabled);
            enqueueSnackbar(response.data.Msg, {
              variant: 'success',
            });
          }
        },
        () => {
          setIsLoading(false);
        }
      );
  };

  /**
   * @function fetchgoodslist
   * @description A function to fetch goods List
   * @returns {Promise} returns an axios promise
   */
  // Demo Changes
  const fetchGoodsList = (queryParams) => {
    setGoodsList([
      {
        _index: 'goods_data',
        _id: 'a12bc45de67f8901234567890abcdef1234567890abcdef1234567890abcdef',
        _score: 1,
        uid: 'a12bc45de67f8901234567890abcdef1234567890abcdef1234567890abcdef',
        name: 'Industrial valves',
        notes: ['84818000, Industrial valves'],
        category: 'Mechanical Equipment',
        entry_date: '2025-06-10',
        exceptions: [],
        regulatory: {
          list_id: 'DUG-002',
          authority: 'Dual Used Goods, GCC',
          list_type: 'Dual Used Goods, GCC',
          watch_list: 'GCC Dual-Use Control List',
          source_url: 'https://www.uaeiec.gov.ae/en-us/control-list-good',
          description:
            'Data on dual-use goods in the GCC, covering trade and compliance.',
          regulator_code: '',
        },
        description:
          'Industrial valves that may have dual-use applications, including use in oil & gas, chemical processing, or controlled fluid systems, subject to export regulations.',
        subcategory: 'Flow Control Equipment',
        dual_use_code: '8481',
        controlled_for: [],
        last_updated_date: '2025-06-10',
        scores: {
          name_match_score: 100,
          dob_match_score: 'N/A',
          address_match_score: 'N/A',
          overall_score: 100,
          id_match_score: 100,
          matched_id: ['100'],
        },
      },
    ]);
    // setIsLoading(true);
    // axios
    //   .get(`${API_ENDPOINTS.INITIAL_SCREENING_GOODS_DETAILS}${queryParams.id}`)
    //   .then((response) => {
    //     setIsLoading(false);
    //     setGoodsList([...response.data]);
    //   })
    //   .catch(() => {
    //     setIsLoading(false);
    //   });
  };

  /**
   * @function fetchSanctionsList
   * @description A function to fetch Sanctions List
   * @returns {Promise} returns an axios promise
   */
  // All changes in this file respective to generateAI are Demo changes - sanctions, pep, ams
  const fetchSanctionsList = (queryParams) => {
    const isNameScreen = queryParams?.card_type === 'name_screen';
    const url = isNameScreen
      ? `${API_ENDPOINTS.INITIAL_SCREENING_CARD_DETAILS}${queryParams.id}/sanction/`
      : `${API_ENDPOINTS.INITIAL_SCREENING_TRANSACTION_ALL_ALERT_LIST}${queryParams.id}/sanction/`;
    const generateAI = queryParams?.generateAI;
    setIsLoading(true);
    axios
      .get(url)
      .then((response) => {
        const data = response?.data;
        if (isNameScreen) {
          const processedSanctionResult = data?.sanction_result.map((item) => ({
            ...item,
            resultType: 'sanctions',
          }));
          const processedSanctionCountryResult =
            data?.sanction_country_result.map((item) => ({
              ...item,
              resultType: 'sanctionsCountry',
            }));
          const processedMnrlResult = data?.mnrl_result.map((item) => ({
            ...item,
            resultType: 'sanctionsMnrl',
          }));

          const mergedResults = [
            ...processedSanctionResult,
            ...processedSanctionCountryResult,
            ...processedMnrlResult,
          ];

          if (generateAI) {
            const sortedResultWithAI = mergedResults.map((item, index) => ({
              ...item,
              comments:
                Dummy_SANCTION_DATA[queryParams.username]?.comments[index] ||
                DEFAULT_COMMENT,
              status:
                Dummy_SANCTION_DATA[queryParams.username]?.status[index] ||
                'notSelected',
            }));
            setSanctionsList(sortedResultWithAI);
          } else {
            setSanctionsList(mergedResults);
          }
        } else {
          const mergedSanctionResult = mergeResults(
            data,
            'sanction_result',
            'sanctions'
          );
          const mergedSanctionCountryResult = mergeResults(
            data,
            'sanction_country_result',
            'sanctionsCountry'
          );
          const mergedMnrlResult = mergeResults(
            data,
            'mnrl_result',
            'sanctionsMnrl'
          );
          const mergedResults = [
            ...mergedSanctionResult,
            ...mergedMnrlResult,
            ...mergedSanctionCountryResult,
          ];
          const sortedResult = sortByParty(mergedResults);
          if (generateAI) {
            const sortedResultWithAI = sortedResult.map((item, index) => ({
              ...item,
              comments:
                Dummy_SANCTION_DATA[queryParams.username]?.comments[index] ||
                DEFAULT_COMMENT,
              status:
                Dummy_SANCTION_DATA[queryParams.username]?.status[index] ||
                'notSelected',
            }));
            setSanctionsList(sortedResultWithAI);
          } else {
            setSanctionsList(sortedResult);
          }
        }
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  };
  /**
   * @function fetchPepList
   * @description A function to fetch Pep List
   * @returns {Promise} returns an axios promise
   */
  const fetchPepList = (queryParams) => {
    const isNameScreen = queryParams?.card_type === 'name_screen';
    const url = isNameScreen
      ? `${API_ENDPOINTS.INITIAL_SCREENING_CARD_DETAILS}${queryParams.id}/pep/`
      : `${API_ENDPOINTS.INITIAL_SCREENING_TRANSACTION_ALL_ALERT_LIST}${queryParams.id}/pep/`;
    const generateAI = queryParams?.generateAI;
    setIsLoading(true);
    axios
      .get(url)
      .then((response) => {
        const { data } = response;
        if (isNameScreen) {
          if (generateAI) {
            const sortedResultWithAI = data.map((item, index) => ({
              ...item,
              comments:
                Dummy_PEP_DATA[queryParams.username]?.comments[index] ||
                DEFAULT_COMMENT,
              status:
                Dummy_PEP_DATA[queryParams.username]?.status[index] ||
                'notSelected',
            }));
            setPepList([...sortedResultWithAI]);
          } else {
            setPepList([...data]);
          }
        } else {
          const mergedPepResult = mergeAllDetails(data);
          const sortedResult = sortByParty(mergedPepResult);
          if (generateAI) {
            const sortedResultWithAI = sortedResult.map((item, index) => ({
              ...item,
              comments:
                Dummy_PEP_DATA[queryParams.username]?.comments[index] ||
                DEFAULT_COMMENT,
              status:
                Dummy_PEP_DATA[queryParams.username]?.status[index] ||
                'notSelected',
            }));
            setPepList(sortedResultWithAI);
          } else {
            setPepList(sortedResult);
          }
        }
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  };
  /**
   * @function fetchAmsList
   * @description A function to fetch Ams List
   * @returns {Promise} returns an axios promise
   */
  const fetchAmsList = (queryParams) => {
    const isNameScreen = queryParams?.card_type === 'name_screen';
    const url = isNameScreen
      ? `${API_ENDPOINTS.INITIAL_SCREENING_CARD_DETAILS}${queryParams.id}/ams/`
      : `${API_ENDPOINTS.INITIAL_SCREENING_TRANSACTION_ALL_ALERT_LIST}${queryParams.id}/ams/`;
    const generateAI = queryParams?.generateAI;
    setIsLoading(true);
    axios
      .get(url)
      .then((response) => {
        const { data } = response;
        if (isNameScreen) {
          if (generateAI) {
            const sortedResultWithAI = data.map((item, index) => ({
              ...item,
              comments:
                Dummy_AMS_DATA[queryParams.username]?.comments[index] ||
                DEFAULT_COMMENT,
              status:
                Dummy_AMS_DATA[queryParams.username]?.status[index] ||
                'notSelected',
            }));
            setAmsList(sortedResultWithAI);
          } else {
            setAmsList(data);
          }
        } else {
          const mergedAmsResult = mergeAllDetails(data);
          const sortedResult = sortByParty(mergedAmsResult);
          if (generateAI) {
            const sortedResultWithAI = sortedResult.map((item, index) => ({
              ...item,
              comments:
                Dummy_AMS_DATA[queryParams.username]?.comments[index] ||
                DEFAULT_COMMENT,
              status:
                Dummy_AMS_DATA[queryParams.username]?.status[index] ||
                'notSelected',
            }));
            setAmsList(sortedResultWithAI);
          } else {
            setAmsList(sortedResult);
          }
        }
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  };
  /**
   * @function fetchLegalList
   * @description A function to fetch legal List
   * @returns {Promise} returns an axios promise
   */
  const fetchLegalList = (queryParams) => {
    const isNameScreen = queryParams?.card_type === 'name_screen';
    const url = isNameScreen
      ? `${API_ENDPOINTS.INITIAL_SCREENING_CARD_DETAILS}${queryParams.id}/legal/`
      : `${API_ENDPOINTS.INITIAL_SCREENING_TRANSACTION_ALL_ALERT_LIST}${queryParams.id}/legal/`;
    setIsLoading(true);
    axios
      .get(url)
      .then((response) => {
        const { data } = response;
        if (isNameScreen) {
          setLegalList([...data]);
        } else {
          const mergedLegalResult = mergeAllDetails(data);
          setLegalList(sortByParty(mergedLegalResult));
        }
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  };
  /**
   * @function fetchCorporateList
   * @description A function to fetch corporate List
   * @returns {Promise} returns an axios promise
   */
  const fetchCorporateList = (queryParams) => {
    const isNameScreen = queryParams?.card_type === 'name_screen';
    const url = isNameScreen
      ? `${API_ENDPOINTS.INITIAL_SCREENING_CARD_DETAILS}${queryParams.id}/corporate/`
      : `${API_ENDPOINTS.INITIAL_SCREENING_TRANSACTION_ALL_ALERT_LIST}${queryParams.id}/corporate/`;
    setIsLoading(true);
    axios
      .get(url)
      .then((response) => {
        const { data } = response;
        if (isNameScreen) {
          setCorporateList([...data]);
        } else {
          const mergedCorporateResult = mergeAllDetails(data);
          setCorporateList(sortByParty(mergedCorporateResult));
        }
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  };
  /**
   * @function fetchLegalDocument
   * @description A function to fetch legal document
   * @returns {Promise} returns an axios promise
   */
  const fetchLegalDocument = (queryParams) => {
    setIsLoading(true);
    axios
      .get(
        `${API_ENDPOINTS.ONGOING_SCREENING_SUMMARY_LEGAL_DOCUMENT}${queryParams.tid}`
      )
      .then((response) => {
        setIsLoading(false);
        setLegalDocument(response?.data?.legal_documents);
      })
      .catch(() => {
        setIsLoading(false);
      });
  };
  /**
   * @function updateListsRow
   * @description A function to update Lists Row
   * @returns {Promise} returns an axios promise
   */
  const updateListsRow = ({ index, value }, listType) => {
    switch (listType) {
      case 'sanctions':
        setSanctionsList((prevState) => {
          const updatedList = [...prevState];
          updatedList[index].status = value;
          return [...updatedList];
        });
        break;
      case 'sanctionsCountry':
        setSanctionsList((prevState) => {
          const updatedList = [...prevState];
          updatedList[index].status = value;
          return [...updatedList];
        });
        break;
      case 'sanctionsMnrl':
        setSanctionsList((prevState) => {
          const updatedList = [...prevState];
          updatedList[index].status = value;
          return [...updatedList];
        });
        break;
      case 'pep':
        setPepList((prevState) => {
          const updatedList = [...prevState];
          updatedList[index].status = value;
          return [...updatedList];
        });
        break;
      case 'ams':
        setAmsList((prevState) => {
          const updatedList = [...prevState];
          updatedList[index].status = value;
          return [...updatedList];
        });
        break;
      case 'legal':
        setLegalList((prevState) => {
          const updatedList = [...prevState];
          updatedList[index].status = value;
          return [...updatedList];
        });
        break;
      case 'corporate':
        setCorporateList((prevState) => {
          const updatedList = [...prevState];
          updatedList[index].status = value;
          return [...updatedList];
        });
        break;
      // Demo Changes - goodsList
      case 'goodsList':
        setGoodsList((prevState) => {
          const updatedList = [...prevState];
          updatedList[index].status = value;
          return [...updatedList];
          // const updatedList = JSON.parse(JSON.stringify(prevState));
          // if (
          //   updatedList &&
          //   updatedList[0] &&
          //   updatedList[0].screening_results &&
          //   updatedList[0].screening_results[index]
          // ) {
          //   updatedList[0].screening_results[index].status = value;
          // }

          // return updatedList;
        });
        break;
      case 'risk':
        setRiskList((prevState) => {
          const updatedList = [...prevState];
          updatedList[index].classification = value;
          return [...updatedList];
        });
        break;
      default:
    }
  };
  const updateAllListsRow = (listType, mode) => {
    switch (listType) {
      case 'sanctions':
        setSanctionsList((prevState) => {
          const updatedList = prevState.map((item) => ({
            ...item,
            status: mode ? 'selected' : mode === null ? false : 'notSelected',
          }));
          return updatedList;
        });
        break;
      case 'sanctionsCountry':
        setSanctionsList((prevState) => {
          const updatedList = prevState.map((item) => ({
            ...item,
            status: mode ? 'selected' : mode === null ? false : 'notSelected',
          }));
          return updatedList;
        });
        break;
      case 'sanctionsMnrl':
        setSanctionsList((prevState) => {
          const updatedList = prevState.map((item) => ({
            ...item,
            status: mode ? 'selected' : mode === null ? false : 'notSelected',
          }));
          return updatedList;
        });
        break;
      case 'pep':
        setPepList((prevState) => {
          const updatedList = prevState.map((item) => ({
            ...item,
            status: mode ? 'selected' : mode === null ? false : 'notSelected',
          }));
          return updatedList;
        });
        break;
      case 'ams':
        setAmsList((prevState) => {
          const updatedList = prevState.map((item) => ({
            ...item,
            status: mode ? 'selected' : mode === null ? false : 'notSelected',
          }));
          return updatedList;
        });
        break;
      case 'legal':
        setLegalList((prevState) => {
          const updatedList = prevState.map((item) => ({
            ...item,
            status: mode ? 'selected' : mode === null ? false : 'notSelected',
          }));
          return updatedList;
        });
        break;
      case 'corporate':
        setCorporateList((prevState) => {
          const updatedList = prevState.map((item) => ({
            ...item,
            status: mode ? 'selected' : mode === null ? false : 'notSelected',
          }));
          return updatedList;
        });
        break;
      // Demo Changes - goodsList
      case 'goodsList':
        setGoodsList((prevState) => {
          const updatedList = prevState.map((item) => ({
            ...item,
            status: mode ? 'selected' : mode === null ? false : 'notSelected',
          }));
          return updatedList;
        });
        break;
      case 'risk':
        setRiskList((prevState) => {
          const updatedList = [...prevState];
          updatedList[index].classification = value;
          return [...updatedList];
        });
        break;
      default:
    }
  };
  /**
   * @function updateListsCommentRow
   * @description A function for updating comments from Lists Row
   * @returns {Promise} returns an axios promise
   */
  const updateListsCommentRow = ({ index, value }, listType) => {
    switch (listType) {
      case 'sanctions':
        setSanctionsList((prevState) => {
          const updatedList = [...prevState];
          updatedList[index].comments = value;
          return [...updatedList];
        });
        break;
      case 'sanctionsCountry':
        setSanctionsList((prevState) => {
          const updatedList = [...prevState];
          updatedList[index].comments = value;
          return [...updatedList];
        });
        break;
      case 'sanctionsMnrl':
        setSanctionsList((prevState) => {
          const updatedList = [...prevState];
          updatedList[index].comments = value;
          return [...updatedList];
        });
        break;
      case 'pep':
        setPepList((prevState) => {
          const updatedList = [...prevState];
          updatedList[index].comments = value;
          return [...updatedList];
        });
        break;
      case 'ams':
        setAmsList((prevState) => {
          const updatedList = [...prevState];
          updatedList[index].comments = value;
          return [...updatedList];
        });
        break;
      case 'legal':
        setLegalList((prevState) => {
          const updatedList = [...prevState];
          updatedList[index].comments = value;
          return [...updatedList];
        });
        break;
      case 'corporate':
        setCorporateList((prevState) => {
          const updatedList = [...prevState];
          updatedList[index].comments = value;
          return [...updatedList];
        });
        break;
      // Demo Changes - goodsList
      case 'goodsList':
        setGoodsList((prevState) => {
          const updatedList = [...prevState];
          updatedList[index].comments = value;
          return [...updatedList];
        });
        break;
      default:
    }
  };

  function getObjectIndexById(array, id) {
    return array?.findIndex((obj) => obj?.id === id);
  }
  const updateAttachmentInCommentRow = (
    fileDetails,
    URL,
    listType,
    operationType = 'add'
  ) => {
    switch (listType) {
      case 'sanctions':
        setSanctionsList((prevState) => {
          const updatedList = [...prevState];
          const index = getObjectIndexById(
            sanctionsList,
            fileDetails?.split('*')?.[0]
          );
          if (operationType !== 'delete') {
            updatedList[index].attached_file = fileDetails;
            updatedList[index].attached_file_url = URL;
          } else {
            updatedList[index].attached_file = '';
            updatedList[index].attached_file_url = URL;
          }

          return [...updatedList];
        });
        break;
      case 'sanctionsCountry':
        setSanctionsList((prevState) => {
          const updatedList = [...prevState];
          const index = getObjectIndexById(
            sanctionsList,
            fileDetails?.split('*')?.[0]
          );
          if (operationType !== 'delete') {
            updatedList[index].attached_file = fileDetails;
            updatedList[index].attached_file_url = URL;
          } else {
            updatedList[index].attached_file = '';
            updatedList[index].attached_file_url = URL;
          }

          return [...updatedList];
        });
        break;
      case 'sanctionsMnrl':
        setSanctionsList((prevState) => {
          const updatedList = [...prevState];
          const index = getObjectIndexById(
            sanctionsList,
            fileDetails?.split('*')?.[0]
          );
          if (operationType !== 'delete') {
            updatedList[index].attached_file = fileDetails;
            updatedList[index].attached_file_url = URL;
          } else {
            updatedList[index].attached_file = '';
            updatedList[index].attached_file_url = URL;
          }

          return [...updatedList];
        });
        break;
      case 'pepList':
        setPepList((prevState) => {
          const updatedList = [...prevState];
          const index = getObjectIndexById(
            pepList,
            fileDetails?.split('*')?.[0]
          );
          if (operationType !== 'delete') {
            updatedList[index].attached_file = fileDetails;
            updatedList[index].attached_file_url = URL;
          } else {
            updatedList[index].attached_file = '';
            updatedList[index].attached_file_url = URL;
          }

          return [...updatedList];
        });
        break;
      case 'amsList':
        setAmsList((prevState) => {
          const updatedList = [...prevState];
          const index = getObjectIndexById(
            amsList,
            fileDetails?.split('*')?.[0]
          );
          if (operationType !== 'delete') {
            updatedList[index].attached_file = fileDetails;
            updatedList[index].attached_file_url = URL;
          } else {
            updatedList[index].attached_file = '';
            updatedList[index].attached_file_url = URL;
          }
          return [...prevState];
        });
        break;
      case 'legal':
        setLegalList((prevState) => {
          const updatedList = [...prevState];
          const index = getObjectIndexById(
            prevState,
            fileDetails?.split('*')?.[0]
          );
          if (operationType !== 'delete') {
            updatedList[index].attached_file = fileDetails;
            updatedList[index].attached_file_url = URL;
          } else {
            updatedList[index].attached_file = '';
            updatedList[index].attached_file_url = URL;
          }
          return [...updatedList];
        });
        break;
      case 'corporate':
        setCorporateList((prevState) => {
          const updatedList = [...prevState];
          const index = getObjectIndexById(
            prevState,
            fileDetails?.split('*')?.[0]
          );
          if (operationType !== 'delete') {
            updatedList[index].attached_file = fileDetails;
            updatedList[index].attached_file_url = URL;
          } else {
            updatedList[index].attached_file = '';
            updatedList[index].attached_file_url = URL;
          }
          return [...updatedList];
        });
        break;
      default:
    }
  };
  /**
   * @function submitSummaryVerdict
   * @description A function to submit Summary Verdict
   * @returns {Promise} returns an axios promise
   */
  const submitSummaryVerdict = (data) => {
    setIsLoading(true);
    const payload = {
      remarks: data.remarks,
      status: (data.verdict?.toLowerCase())[0] === 'a' ? 'a' : 'r',
      results: {
        ams_result: data.ams_result,
        pep_result: data.pep_result,
        sanction_result: data.sanction_result,
        sanction_country_result: data.sanction_country_result,
        legal_result: data.legal_result,
        mnrl_result: data.mnrl_result,
        corporate_result: data.corporate_result,
        ...(data?.risk
          ? {
              risk_rating_result: data?.risk_rating_result,
              risk_type: data?.risk_type,
              risk_rating: data?.risk_rating,
            }
          : {}),
      },
      attachment: data?.attachment,
      move_search_to_om: data?.move_search_to_om,
    };
    return axios
      .post(
        `${API_ENDPOINTS.INITIAL_SCREENING_SUMMARY_VERDICT}${data.id}/`,
        payload
      )
      .then(
        () => {
          setIsLoading(false);
        },
        () => {
          setIsLoading(false);
        }
      );
  };

  const submitBulkVerdict = (payload) => {
    setIsLoading(true);
    return postBulkVerdict({
      scope: 'initial',
      payload,
      enqueueSnackbar,
    }).finally(() => setIsLoading(false));
  };

  // Demo Changes - submitGoodsVerdict
  const submitGoodsVerdict = (data) => {
    setIsLoading(true);
    const payload = {
      remarks: data.remarks,
      status: (data.verdict?.toLowerCase())[0] === 'a' ? 'a' : 'r',
      results: {
        goods_result: data.goods_result,
      },
      attachment: data?.attachment,
    };
    return axios
      .post(`${API_ENDPOINTS.SUBMIT_GOODS_DETAILS}${data.id}/`, payload)
      .then(
        () => {
          setIsLoading(false);
          // enqueueSnackbar('Verdict submitted successfully.', {
          //   variant: 'success',
          // });
        },
        () => {
          setIsLoading(false);
        }
      );
  };

  /**
   * @function submitRequestReferral
   * @description A function to submit Request Referral
   * @returns {Promise} returns an axios promise
   */
  const submitRequestReferral = (data) => {
    setIsLoading(true);
    const payload = {
      description: data.remarks,
      requested_to: data.analystName,
      attachment: data?.attachment,
      ...(data?.transaction_my_queue_referral_submit && {
        transaction_my_queue_referral_submit:
          data?.transaction_my_queue_referral_submit,
      }),
      results: {
        ...(data?.transaction_my_queue_referral_submit
          ? data?.results
          : {
              sanction_result: data.sanction_result,
              pep_result: data.pep_result,
              ams_result: data.ams_result,
              corporate_result: data.corporate_result,
              legal_result: data.legal_result,
              sanction_country_result: data?.sanction_country_result,
              mnrl_result: data?.mnrl_result,
              risk_rating_result: data?.risk_rating_result,
            }),
      },
    };
    return axios
      .post(
        `${API_ENDPOINTS.INITIAL_SCREENING_REQUEST_ANALYST}${data.id}/`,
        payload
      )
      .then(
        () => {
          setIsLoading(false);
          enqueueSnackbar('Refer sent successfully.', {
            variant: 'success',
          });
        },
        () => {
          setIsLoading(false);
        }
      );
  };
  /**
   * @function submitReferral
   * @description A function submit Referral
   * @returns {Promise} returns an axios promise
   */
  const submitReferral = (data) => {
    setIsLoading(true);
    const payload = {
      comments: data.remarks,
      attachment: data?.attachment,
    };
    return axios
      .post(
        `${API_ENDPOINTS.INITIAL_SCREENING_REQUEST_ANALYST}${data.id}/`,
        payload
      )
      .then(
        () => {
          setIsLoading(false);
          enqueueSnackbar('Refer sent successfully.', {
            variant: 'success',
          });
        },
        () => {
          setIsLoading(false);
        }
      );
  };
  /**
   * @function fetchDedupeParameter
   * @description function for fetching deduplication parameters
   * @returns {Promise} returns an axios promise
   */
  const fetchDedupeParameter = () => {
    setIsLoading(true);
    axios
      .get(API_ENDPOINTS.DEDUPLICATION_PARAMETER)
      .then((response) => {
        setDedupeParameter(response.data);
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  };
  /**
   * @function fetchDedupeInformation
   * @description function for fetching deduplication information
   * @returns {Promise} returns an axios promise
   */
  const fetchDedupeInformation = (data) => {
    setIsLoading(true);
    axios
      .get(API_ENDPOINTS.DEDUPLICATE_INFORMATION, { params: data })
      .then((response) => {
        if (data?.transaction_type === 'Payer' || !data?.transaction_type) {
          setDedupeInformation(response.data);
        } else {
          setRecipientDedupeInformation(response.data);
        }
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  };
  /**
   * @function updateDedupeInformation
   * @description function for updating deduplication information
   * @returns {Promise} returns an axios promise
   */
  const updateDedupeInformation = (data) => {
    const body = {
      ...data,
    };

    return axios.post(API_ENDPOINTS.DEDUPLICATE_INFORMATION, body).then(
      (response) => {
        if (response) {
          enqueueSnackbar(
            'Deduplication for the selected searches has been successfully completed.',
            {
              variant: 'success',
            }
          );
        }
      },
      () => {
        setIsLoading(false);
      }
    );
  };
  const addToBookmark = (data) => {
    const body = {
      ...data,
    };

    return axios.patch(API_ENDPOINTS.INITIAL_ONGOING_BOOKMARK, body).then(
      (response) => {
        if (response) {
          // enqueueSnackbar(
          //   'Deduplication for the selected searches has been successfully completed.',
          //   {
          //     variant: 'success',
          //   }
          // );
        }
      },
      () => {
        setIsLoading(false);
      }
    );
  };

  const assignToSelf = (data, isSelf = true) => {
    const body = {
      ...data,
    };
    return axios
      .post(API_ENDPOINTS.INITIAL_ONGOING_COMMON_SEARCHES_ASSIGN, body)
      .then(
        (response) => {
          if (response) {
            enqueueSnackbar(
              isSelf
                ? 'Searches assigned to you successfully'
                : 'Searches assigned successfully',
              {
                variant: 'success',
              }
            );
          }
        },
        () => {
          setIsLoading(false);
        }
      );
  };
  const uploadAttachedFiles = (payload) => {
    setIsLoading(true);
    return axios
      .post(API_ENDPOINTS.GET_BULK_PRESIGNED_URL, payload)
      .then((res) => {
        setIsLoading(false);
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const deleteFile = ({ id, row, type }) => {
    const data = { filename: `${id}*${row?.attached_file}` };
    return axios
      .delete(`${API_ENDPOINTS.DELETE_FILE}`, { params: data })
      .then((res) => {
        updateAttachmentInCommentRow(
          `${id}*${row?.attached_file}`,
          '',
          type,
          'delete'
        );
        return res;
      })
      .catch((error) => {
        enqueueSnackbar(error?.response?.data?.error, {
          variant: 'error',
        });
        throw error;
      });
  };
  const uploadFileOns3 = (uploadUrl, file) => {
    return axios
      .put(uploadUrl, file, {
        headers: {
          'Content-Type': file.type,
        },
      })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        throw error;
      });
  };
  /**
   * @function fetchTemplateList
   * @description A function to fetch team data
   * @returns {Promise} returns an axios promise
   */
  const fetchTemplateList = () => {
    setIsLoading(true);
    return axios.get(API_ENDPOINTS.SAR_CONFIGURATION).then(
      (response) => {
        setIsLoading(false);
        setTemplateList(response?.data);
      },
      (e) => {
        enqueueSnackbar(e?.response?.data?.error, {
          variant: 'error',
        });
        setIsLoading(false);
      }
    );
  };

  /**
   * @function fetchTemplateList
   * @description A function to fetch team data
   * @returns {Promise} returns an axios promise
   */
  const fetchTemplate = (data) => {
    setIsLoading(true);
    return axios.get(API_ENDPOINTS.GET_TEMPLATE, { params: data }).then(
      (response) => {
        setIsLoading(false);
        setTemplate(response?.data);
        return response;
      },
      (e) => {
        enqueueSnackbar(e?.response?.data?.error, {
          variant: 'error',
        });
        setIsLoading(false);
      }
    );
  };
  const transferSeaches = (data) => {
    const body = {
      ...data,
    };
    return axios.post(API_ENDPOINTS.INITIAL_ONGOING_TRANSFER_CASES, body).then(
      (response) => {
        if (response) {
          enqueueSnackbar('Transfered the searches successfully', {
            variant: 'success',
          });
        }
      },
      () => {
        setIsLoading(false);
      }
    );
  };
  const transferSeachesList = (data) => {
    setIsLoading(true);

    const updatedParams = {
      ...data,
    };
    delete updatedParams?.screenType;
    const params = CoreUtils.convertArrayParamsToString(updatedParams);
    return axios
      .get(
        `${API_ENDPOINTS.INITIAL_ONGOING_TRANSFER_CASE_LIST}${data.screenType}`,
        {
          params,
        }
      )
      .then(
        (response) => {
          if (response) {
            setIsLoading(false);
            setTransferList(response?.data);
          }
          return response;
        },
        () => {
          setIsLoading(false);
        }
      );
  };

  const getTransferData = ({ page = 0, pageSize = 5, filters = {} } = {}) => {
    const modifiedFilters = CoreUtils.buildModifiedFilters(filters || {});
    // Always pass all required keys, use empty string if not present
    const params = {
      page: page + 1 || '',
      pagesize: pageSize || '',
      progress_status: modifiedFilters?.searchStatus ?? '',
      start_date: modifiedFilters?.transferDateRange?.start
        ? moment(modifiedFilters?.transferDateRange?.start).format(
            consts.GLOBAL_DATE_FORMAT
          )
        : '',
      end_date: modifiedFilters?.transferDateRange?.end
        ? moment(modifiedFilters?.transferDateRange?.end).format(
            consts.GLOBAL_DATE_FORMAT
          )
        : '',
      searched_field: modifiedFilters?.search ?? '',
      to_team: modifiedFilters?.transferredTeam ?? '',
      to_user: modifiedFilters?.transferredUser ?? '',
      transfer_type: modifiedFilters?.transferType ?? '',
      transaction_screening:
        modifiedFilters?.module === 'transaction_screening',
      search_format: modifiedFilters?.search_format ?? '',
    };
    return axios
      .get(`${API_ENDPOINTS.INITIAL_ONGOING_TRANSFER_CASE_LIST}initial`, {
        params,
        loader: false,
      })
      .then((res) => {
        return {
          data: res?.data,
          totalRowCount: res.headers?.['x-total-count'],
        };
      });
  };

  /**
   * @function handleTransactionReWork
   * @description A function to post transaction re work details
   * @returns {Promise} returns an axios promise
   */
  const handleTransactionReWork = (queryParams) => {
    setIsLoading(true);
    resetAllList();
    const payload = {
      comment: queryParams?.comment,
      attachment: queryParams?.file?.name,
      results: queryParams?.results,
    };

    return axios
      .post(
        `${API_ENDPOINTS.INITIAL_TRANSACTION_REWORK}${queryParams?.data?.internal_transaction_id}/`,
        payload
      )
      .then(
        (response) => {
          setIsLoading(false);
          if (response?.data) {
            enqueueSnackbar(response?.data?.message, {
              variant: 'success',
            });
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        },
        (response) => {
          setIsLoading(false);
          enqueueSnackbar(response?.response?.data?.message, {
            variant: 'error',
          });
        }
      );
  };

  const submitTransactionSummaryVerdict = (data) => {
    setIsLoading(true);
    const payload = {
      remarks: data.remarks,
      status: data.verdict?.toLowerCase()?.[0] === 'a' ? 'a' : 'r',
      results: data?.results,
      attachment: data?.attachment,
      move_search_to_om: data?.move_search_to_om,
    };
    return axios
      .post(
        `${API_ENDPOINTS.INITIAL_SCREENING_TRANSACTION_VERDICT}${data.id}/`,
        payload
      )
      .then(
        () => {
          setIsLoading(false);
          enqueueSnackbar('Verdict submitted successfully.', {
            variant: 'success',
          });
        },
        () => {
          setIsLoading(false);
        }
      );
  };

  return {
    user,
    fetchUsers,
    fetchTransactionUsers,
    userList,
    setUserList,
    updateUser,
    fetchSanctionsList,
    fetchPepList,
    fetchAmsList,
    fetchLegalList,
    fetchCorporateList,
    sanctionsList,
    pepList,
    amsList,
    legalList,
    corporateList,
    legalDocument,
    fetchLegalDocument,
    updateListsRow,
    updateAllListsRow,
    updateListsCommentRow,
    isLoading,
    setRiskList,
    submitSummaryVerdict,
    submitBulkVerdict,
    fetchUsersPageCount,
    totalUsers,
    disabled,
    setdisabled,
    fetchCardData,
    fetchTransactionCardData,
    cardDetails,
    setCardDetails,
    analystsList,
    fetchReferralsList,
    submitReferral,
    submitRequestReferral,
    referralList,
    hasData,
    setHasData,
    fetchDedupeInformation,
    dedupeInformation,
    recipientDedupeInformation,
    updateDedupeInformation,
    setDedupeInformation,
    fetchDedupeParameter,
    dedupeParameter,
    riskList,
    riskValue,
    riskResult,
    setRiskValue,
    fetchRiskList,
    calculateRiskRating,
    getRiskParameters,
    riskParameters,
    industry,
    product,
    occupation,
    systemRisk,
    setSystemRisk,
    riskResponse,
    crrMandatoryParameterList,
    addToBookmark,
    moveIsToOm,
    assignToSelf,
    getTransactionParameters,
    channel,
    productType,
    transactionType,
    uploadAttachedFiles,
    updateAttachmentInCommentRow,
    deleteFile,
    uploadFileOns3,
    handleReview,
    fetchTemplateList,
    templateList,
    fetchTemplate,
    template,
    fetchUserList,
    transferSeaches,
    transferSeachesList,
    transferList,
    getTransferData,
    getInitialScreeningData,
    getInitialTransactionUsers,
    handleTransactionReWork,
    initialScreeningTotalCount,
    submitTransactionSummaryVerdict,
    // Demo Changes
    fetchGoodsList,
    goodsList,
    submitGoodsVerdict,
  };
}
